
import * as _ from 'underscore'
import { DataProvider, ReferenceTypeComponent } from "../helpers"

import { Enums } from "../models/common"
import { OpDepositoryElement, OpPackage, OpPackageStatus } from "../models/core"
import { ColumnInfo, OpPackageStatusFlow, OpEquipmentQuantity, OpValidateInfo } from "../models/custom"

export class DataProviderOrder {

    //#region Consts

    private static get LOG_PREFIX(): string { return '[SIMAX.DataProvider.Order]' }

    //#endregion

    //#region Ctor

    constructor(private dataProvider: DataProvider) { }

    //#endregion End


    //#region Get

    public getOrderFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpPackage>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdPackage, 'OpxOrderFilter', 'OpxOrderFilterResult')
    }

    public getOrder = (idOrder: number): JQueryPromise<OpPackage> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetOrder', { IdOrder: idOrder }, 'OpxGetOrderResult')
            .then((response: any) => {
                if (response != null) {
                    const order: OpPackage = new OpPackage(response)

                    return OpPackage
                        .loadNavigationProperties(this.dataProvider, [order])
                        .then((order: OpPackage[]) => {
                            return _.first(order)
                        })
                }

                return null
            })
    }

    //#endregion


    //#region Save

    public saveOrder = (order: OpPackage): JQueryPromise<OpPackage> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveOrder', { ToBeSaved: order.toJSON() }, 'OpxSaveOrderResult')
            .then((response: any) => {
                if (response != null) {
                    const order: OpPackage = new OpPackage(response)

                    return OpPackage
                        .loadNavigationProperties(this.dataProvider, [order])
                        .then((order: OpPackage[]) => {
                            return _.first(order)
                        })
                }

                return null
            })
    }

    //#endregion


    //#region Status

    public getOrderStatusFlow = (): JQueryPromise<OpPackageStatusFlow[]> => {
        return this.dataProvider.System.getFlow<OpPackageStatusFlow>(Enums.DataType.HELPER_ID_ORDER_STATUS)
    }

    public getNextOrderStatuses = (orderStatus: Enums.PackageStatus): JQueryPromise<OpPackageStatus[]> => {
        return this.dataProvider.System.getFlowByStatus<OpPackageStatusFlow, OpPackageStatus>(Enums.DataType.HELPER_ID_ORDER_STATUS, (status: OpPackageStatusFlow) => status.packageStatus.idPackageStatus === orderStatus)
    }

    //#endregion


    //#region Delete

    public deleteOrder = (opObj: OpPackage): JQueryPromise<OpPackage> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveOrder', { ToBeSaved: opObj.toJSON() }, 'OpxSaveOrderResult')
            .then((data: any) => {
                const result: OpPackage = new OpPackage(data)

                OpPackage.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }

    //#endregion


    public validateOrderContent = (depositoryContent: OpDepositoryElement[]): JQueryPromise<OpValidateInfo[]> => {
        return this.dataProvider.sendRequestWithSession('OpxValidateOrderContent', { content: depositoryContent }, 'OpxValidateOrderContentResult')
            .then((response: any) => {
                return response.map((valdiationObj: any) => {
                    valdiationObj.ReferenceValue = ReferenceTypeComponent.createReferenceObject(valdiationObj.ReferenceType, valdiationObj.ReferenceValue)

                    return new OpValidateInfo(valdiationObj)
                })
            })
    }

    public getIncompleteOrderContent = (idOrder: number[]): JQueryPromise<OpDepositoryElement[]> => {
        return this.dataProvider.sendRequestWithSession('OpxGetIncompleteOrderContent', { idOrder: idOrder }, 'OpxGetIncompleteOrderContentResult')
            .then((response: OpDepositoryElement[]) => {

                return response.map(e => new OpDepositoryElement(e))
            })
    }

    public getOrderDestinationMagazine = (idOrder: number[]): JQueryPromise<OpPackage[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetOrderDestinationMagazine', { idOrder: idOrder }, 'OpxGetOrderDestinationMagazineResult')
            .then((result: any) => {
                return result.map((e: any) => new OpPackage(e))
            })
    }

    public getOrderEquipmentCollection = (idOrder: number[]): JQueryPromise<OpEquipmentQuantity[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetOrderEquipmentCollection', { idOrder: idOrder }, 'OpxGetOrderEquipmentCollectionResult')
            .then((result: any) => {
                return result.map((e: any) => new OpEquipmentQuantity(e))
            })
    }


    //#endregion
}